(function () {
    const SELECTORS = {
        root: "[data-mb-mobile-nav-root]",
        toggle: "[data-mb-mobile-menu-toggle]",
        nav: "[data-mb-mobile-nav]",
        header: "[data-mb-header]",
        banner: "[data-announcement-banner]",
        promo_banner: "[data-promo-banner]",
    };

    // --- Dynamic header height -> CSS var ---
    function setHeaderHeightVar() {
        const header = document.querySelector(SELECTORS.header);
        const banner = document.querySelector(SELECTORS.banner);
        const promo_banners = document.querySelectorAll(SELECTORS.promo_banner);
        if (!header) return;

        const header_height = header?.getBoundingClientRect()?.height || 0
        const banner_height = banner?.getBoundingClientRect()?.height || 0
        const promo_height = Array.from(promo_banners).reduce((height, promo_banner) => {
            return height + (promo_banner.classList.contains("promo-hidden")
                ? 0
                : promo_banner.getBoundingClientRect().height);
        }, 0);

        const height = header_height + banner_height + promo_height

        document.documentElement.style.setProperty("--header-height", `${height}px`);

    }

    function OpenNav(root) {
        const toggle = root.querySelector(SELECTORS.toggle);
        const nav = root.querySelector(SELECTORS.nav);
        const header = document.querySelector(SELECTORS.header);

        if (!toggle || !nav) return;

        header.scrollIntoView({ behavior: "smooth" });
        requestAnimationFrame(() => {
            document.documentElement.classList.add("mb-scroll-locked");
        });


        toggle.setAttribute("aria-open", "true");
        nav.setAttribute("aria-hidden", "false");


    }

    function CloseNav(root) {
        const toggle = root.querySelector(SELECTORS.toggle);
        const nav = root.querySelector(SELECTORS.nav);

        if (!toggle || !nav) return;

        toggle.setAttribute("aria-open", "false");
        nav.setAttribute("aria-hidden", "true");

        document.documentElement.classList.remove("mb-scroll-locked");
    }

    function toggleMobileNav(root) {
        const toggle = root.querySelector(SELECTORS.toggle);
        if (!toggle) return;

        const isOpen = toggle.getAttribute("aria-open") === "true";
        if (isOpen) CloseNav(root);
        else OpenNav(root);
    }

    function initMobileNav(root) {
        const toggle = root.querySelector(SELECTORS.toggle);
        const nav = root.querySelector(SELECTORS.nav);

        if (!toggle || !nav) return;

        // initial state
        if (!toggle.hasAttribute("aria-open")) toggle.setAttribute("aria-open", "false");
        if (!nav.hasAttribute("aria-hidden")) nav.setAttribute("aria-hidden", "true");

        // toggle click
        toggle.addEventListener("click", (e) => {
            e.preventDefault();
            toggleMobileNav(root);
        });

        // close on ESC
        document.addEventListener("keydown", (e) => {
            if (e.key !== "Escape") return;
            CloseNav(root);
        });

        // close when clicking a link inside nav
        nav.addEventListener("click", (e) => {
            const link = e.target.closest("a");
            if (!link) return;

            if (link.getAttribute("href") === "#" || link.hasAttribute("data-no-close")) {
                return;
            }

            CloseNav(root);
        });
    }

    function initAll(scope) {
        setHeaderHeightVar();
        scope.querySelectorAll(SELECTORS.root).forEach(initMobileNav);
    }

    document.addEventListener("DOMContentLoaded", () => {
        initAll(document);

        window.addEventListener("resize", setHeaderHeightVar);
        document.addEventListener("promo-banner:state-change", () => {
            requestAnimationFrame(setHeaderHeightVar);
        });
        const header = document.querySelector(SELECTORS.header);
        if (header && window.ResizeObserver) {
            const ro = new ResizeObserver(setHeaderHeightVar);
            ro.observe(header);
        }
    });

    document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();
